import { useRelatedProducts } from "@algolia/recommend-react";
import styled from "styled-components";
import { Box, FlexGrid, Heading, Section, Stack } from "@vinomofo/components";
import { RelatedOffersList } from "./RelatedOffersList";
import { RelatedItemsProps } from "./types";
import { VinoDataOffer } from "../../types/vino-data-types";
import { useEffect } from "react";
import { trackOfferListEvent } from "../../utils/event-tracking";
import { debounce } from "../../utils/debounce";
import { OfferHit } from "../product-collection/ProductCollection";
import { recommendClient } from "../../utils/recommend-client";

const StyledSection = styled(Section)`
  background-color: #fff;
  padding-bottom: 40px;
  > div > div > div {
    overflow: inherit;
  }

  @media (max-width: 1160px) {
    background-color: ${({ backgroundColor }) => backgroundColor || "#fff"};
  }
`;

const trackProductListViewed = debounce((hits: OfferHit[]) => {
  trackOfferListEvent("Product List Viewed", hits);
}, 500);

const RelatedProductItems = (props: RelatedItemsProps) => {
  const {
    offerIds,
    heading,
    backgroundColor,
    indexName,
    category,
    isSpirit,
  } = props;
  const finalCategory = category === "Mystery" ? "Red" : category; // added as Mystery category has only couple of offers.

  const baseFilters = `("inventoryStatus":"AVAILABLE") AND ("hidden":"false") AND ("tiersEligible":"ALL") AND ("channels":"Site")`;
  const categoryFilter = isSpirit
    ? `("isSpirit":"true")`
    : `("category":"${finalCategory}")`;
  const filters = `${categoryFilter} AND ${baseFilters}`;
  const fallbackFilters = isSpirit
    ? `("isSpirit":"true") AND ${baseFilters}`
    : `${baseFilters}`;

  const { recommendations, status } =
    indexName && offerIds
      ? useRelatedProducts({
          recommendClient,
          indexName: indexName || "",
          objectIDs: offerIds ? offerIds : [],
          maxRecommendations: 30,
          queryParameters: {
            filters,
            clickAnalytics: true,
          },
          fallbackParameters: {
            filters: fallbackFilters,
            clickAnalytics: true,
          },
        })
      : { recommendations: [], status: "idle" };

  useEffect(() => {
    if (recommendations?.length > 0) {
      trackProductListViewed(recommendations.slice(0, 4));
    }
  }, [recommendations]);

  return recommendations.length > 0 ? (
    <StyledSection>
      <Box width="100%">
        <FlexGrid gutter={1} display={["block"]}>
          {heading && (
            <Stack space={2}>
              {heading && (
                <Heading as="h3" variant="lg" textAlign="center">
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    padding={["40px"]}
                  >
                    {heading}
                  </Box>
                </Heading>
              )}
            </Stack>
          )}
          <RelatedOffersList
            backgroundColor={backgroundColor}
            recommendedOffers={recommendations.slice(0, 4) as VinoDataOffer[]}
            isLoading={status === "loading"}
            isShoppingCartPage={false}
            engine={"algolia"}
            {...props}
          />
        </FlexGrid>
      </Box>
    </StyledSection>
  ): <></>;
};

export default RelatedProductItems;
